const initialState = {
  exclusive: {
    count: 0,
    enabled: false,
    mode: null,
  },
  global: {
    type_prefixes: '',
    company_prefix: '',
    mode: null,
  },
  config: {
    allow_manual_edit: false,
    loading: false,
    error: false,
  },
  previousExclusive: null,
  previousAllowManualEdit: null,
  globalConfig: {
    development_types: [],
    property_types: [],
    company_prefix: '',
    mode: null,
    loading: false,
    error: false,
  },
  exclusiveConfig: {
    branches: [],
    users: [],
    mode: null,
    team_supported: false,
    loading: false,
    error: false,
    hasLoaded: false,
  },
};

export default initialState;
